import { useEffect, useRef } from "react";
import { useLazyTwitchCodeAuthQuery } from "../../api/authApi";
import { useQuery } from "../../hooks/useQuery";
import { useDispatch } from "react-redux";
import { setAuthenticated } from "../../slices/authSlice";
import { Suspense } from "react";
import { Spinner } from "grommet";
import { useNavigate } from "react-router-dom";

export const AuthCallback = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const query = useQuery();
    const callbackStarted = useRef(false);

    const [twitchCodeAuth] = useLazyTwitchCodeAuthQuery();

    useEffect(() => {
        if (callbackStarted.current) {
            return;
        }
        callbackStarted.current = true;

        const code = query.get('code');
        const state = query.get('state');
        if (!code || !state) {
            dispatch(setAuthenticated(false));
            navigate('/', { replace: true });
            return;
        }

        twitchCodeAuth({ code, state })
            .unwrap()
            .then(({ redirectUri }) => {
                // This is only a UI marker. Backend authorization relies solely on its session.
                dispatch(setAuthenticated(true));
                navigate(redirectUri || '/', { replace: true });
            })
            .catch(() => {
                dispatch(setAuthenticated(false));
                navigate('/', { replace: true });
            });
    }, [dispatch, navigate, query, twitchCodeAuth])

    return (
        <Suspense fallback={<Spinner />} />
    )
}
